import { inputClasses } from '@ori-ui/mui-bundle/material';
import { textInputData } from '../constants';

// text field

const styleOverrides = {
  root: {
    fontSize: textInputData.input.size,
    [`&.${inputClasses.root}.${inputClasses.disabled}:before`]: {
      borderBottomStyle: 'solid'
    }
  },
  input: {
    '&&:-webkit-autofill': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }
  }
};
const defaultProps = {
  color: 'inputElements'
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiInputBase.js.map